import React from 'react'
import { motion } from 'framer-motion';
import Classes from './SidebarPopup.module.css'
import Sidebar from '../Sidebar/Sidebar';

export default function SidebarPopup({
    isMobile,
    setopenMobileSidebar,
}) {
    const handleBgClick = () => {
        setopenMobileSidebar(false);
    };

    const handleCardClick = (e) => {
        e.stopPropagation();
    };

    return (
        <>
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                className={Classes.popup}
                onClick={handleBgClick}
            >
                <motion.div
                    initial={{ opacity: 0, x: -15 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -15 }}
                    transition={{ duration: 0.15 }}
                    onClick={handleCardClick}
                >
                    <Sidebar
                        isMobile={isMobile}
                        setopenMobileSidebar={setopenMobileSidebar}
                    />
                </motion.div>
            </motion.div>
        </>
    )
}
